// extracted by mini-css-extract-plugin
export default {"BannerTwo":"BannerTwo_BannerTwo__ZrJ5V","quote":"BannerTwo_quote__i0-WK"};